import React from 'react';
import styled, { keyframes } from 'styled-components';
import { themeGet } from 'styled-system';
import { basicTheme } from 'src/theme';
import { PositionBox, PositionBoxProps } from './Box';

export type InputLoaderProps = PositionBoxProps & {
  size?: keyof typeof basicTheme.controlSizes;
};
export const InputLoader = (props: InputLoaderProps) => (
  <StyledLoaderContainer {...props}>
    <div css={{ position: 'relative', height: '100%' }}>
      <StyledSpinner />
    </div>
  </StyledLoaderContainer>
);

const StyledLoaderContainer = styled(PositionBox)<{ size: string }>`
  position: absolute;
  z-index: 100;
  padding: ${props => themeGet('sizes.' + props.size)(props) / 4}px;
  height: ${props => themeGet('sizes.' + props.size)}px;
  width: ${props => themeGet('sizes.' + props.size)}px;
`;
StyledLoaderContainer.defaultProps = {
  top: 0,
  right: 0
};

const animation = keyframes`
   0% {
        transform: rotate(0deg);
        border-top-color: ${themeGet('colors.primary')};
        border-right-color: ${themeGet('colors.primary')};
     }
     100% {
        transform: rotate(720deg);
        border-top-color: ${themeGet('colors.primary')};
        border-right-color: ${themeGet('colors.primary')};
     }
`;

const StyledSpinner = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0);
  border-top-color: ${themeGet('colors.primary')};
  border-right-color: ${themeGet('colors.primary')};
  animation: ${animation} 2s infinite linear;
`;
